import {Pipe, PipeTransform} from '@angular/core';
import {MessageTranslateService} from "@shared/services";

// convert into array of options for use in dropdown, so have value and translation as label
// optional param displayMap is map of values to display labels which will be translated
@Pipe({name: 'enumOptions', standalone: false})
export class EnumOptionsPipe implements PipeTransform {

    constructor(private translateService: MessageTranslateService) {}

    transform<T>(value: T, displayMap?: Map<T, string>): {value: T, label: string} {
      if (value != null) {
        return Object.values(value).reduce((acc, v) => {
          // Do not display functions. It is possible to attach functions to enums by using a "namespace" with the same
          // name as the enum
          if (v != null && (typeof v) !== 'function') {
            acc.push({value: v, label: this.translateService.instant(displayMap?.get(v) || v.toString())});
          }
          return acc;
        }, []);
      } else {
        return null;
      }
    }
}
